import React, { useRef, useState, useEffect } from "react";
import { Button } from "./Button";
import { DefaultQuestionsProps } from "../types";

const DefaultQuestions: React.FC<DefaultQuestionsProps> = ({
  questions,
  onQuestionClick
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  if (!questions || questions.length === 0) return null;

  return (
    <div
      className={`relative px-2 sm:px-4 py-2 shadow-sm transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        ref={scrollContainerRef}
        className={`flex overflow-x-auto scrollbar-hide gap-1.5 sm:gap-2 pb-1 transition-all duration-300 ease-out ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
        }`}
      >
        {questions.map((question, idx) => (
          <Button
            key={idx}
            variant="outline"
            size="sm"
            className="flex-shrink-0 text-xs sm:text-sm px-3 sm:px-4 py-1 h-auto rounded-full whitespace-nowrap bg-white border-zinc-200 hover:bg-zinc-50 hover:border-zinc-300 transition-all shadow-sm"
            onClick={() => onQuestionClick(question)}
            style={{
              transitionDelay: `${idx * 50}ms`,
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(8px)"
            }}
          >
            {question}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default DefaultQuestions;
